
export class LayoutSubgrid {
    public EntityName: string = '';
    public IsDefault: boolean = false;
    public ProjectionRelationName: string = null;
}